import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../reusable/GlobalMeta";
//import PageContent from "../layout/PageContent";
import { Link, useParams } from "react-router-dom";
import he from 'he';
import { Box, Container } from "@mui/system";
import { Fade, Grid, Skeleton, Typography } from "@mui/material";
import Buildings from "../images/building.png";
import WaveReverse from "../images/wave-reverse.png";
import WPAPI from 'wpapi';
import parseReactComponents from "../functions/parseReactComponents";
import InternalBanner from "../reusable/fieldGroups/InternalBanner";
import { Link as RouterLink } from 'react-router-dom';
import ImageBGSection from "../reusable/fieldGroups/ImageBGSection";
export default function Page(){

	const {'*':slug}=useParams();
     
    const [pageData, setPageData]=useState();
	const [notFound, setNotFound]=useState(false);
	const [displaySidebar, setDisplaySidebar] = useState(false);

    //Fetch page
    const { isPending, isError, data, error }=useQuery(
        ['page', slug], //Query key and dependency
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/pages?slug='+slug+'&_embed=true&acf_format=standard'
        })
    );

    useEffect(()=>{
        if(data?.data){
            if(data.data.length){
				setPageData(data.data[0]);
				setNotFound(false);
			}
			else{
				setNotFound(true);
			}
       }
	}, [data]);

	console.log('pageData - ' + slug, pageData)

	useEffect(() => {
		if (pageData) {
			const displaySidebar = pageData?.acf?.display_sidebar;
			if (displaySidebar === true) {
				setDisplaySidebar(displaySidebar);
			}
		}
		//cleanup
		return () => {
			setDisplaySidebar(false);
		}
	}, [pageData]);

	const [menu, setMenu] = useState();

	//Fetch footer menu
	const wp = new WPAPI({ endpoint: WP_API_Settings.endpoint }); //custom API in functions.php
	wp.menus = wp.registerRoute(
		'wp/v2',
		'menu-tree',
		{
			params: [
				'menu'
			]
		}
	);
	useEffect(() => {
		wp.menus().menu("custom-menu").then((menuData) => {
			setMenu(menuData);
		});
	}, []);

	console.log('menu', menu)

	return (
		<>

			<GlobalMeta />

			{pageData?._embedded?.['wp:featuredmedia']?.[0]?.source_url &&
				<InternalBanner
					featuredImage={pageData._embedded['wp:featuredmedia'][0].source_url}
					banner={pageData.acf.internal_banner}
				/>
			}




			{!pageData?._embedded?.['wp:featuredmedia']?.[0]?.source_url &&
				<>
					<Box
						sx={{
							backgroundColor: '#1B314A',
							color: '#fff',
							mb: '-3rem'
						}}
					>
						<Box
							sx={{
								width: '100%',
								height: '100%',
								backgroundImage: 'url(' + Buildings + ')',
								backgroundSize: {
									xs: '100%',
									md: '50% auto'
								},
								backgroundRepeat: 'no-repeat',
								backgroundPosition: 'bottom right'
							}}
						>
							<Container maxWidth='xl'
								sx={{
									p: '3rem 0'
								}}
							>
								<Typography variant='h1'
									sx={{
										fontSize: '3rem',
										fontWeight: 600
									}}
								>
									{notFound ? 'Oops! Page not found' : pageData ? he.decode(pageData.title.rendered) : <Skeleton />}
								</Typography>
							</Container>
							<Box
								sx={{
									height: '12vw',
									backgroundImage: 'url(' + WaveReverse + ')',
									backgroundSize: 'cover',
									backgroundRepeat: 'no-repeat',
								}}
							/>
						</Box>
					</Box>

				</>
			}

			<Container maxWidth='xl'
				sx={{
					m: '3rem auto'
				}}
			>
				<Fade in={true} >
					<Grid container spacing={4} alignItems="flex-start" justifyContent="flex-start">
						<Grid item xs={12} md={displaySidebar ? 8 : 12}>
							<article id={pageData?.slug}>
								{pageData?.content?.rendered ?
									parseReactComponents(pageData.content.rendered)
									:
									null}
							</article>
						</Grid>
						{displaySidebar &&
							<Grid item xs={12} md={4}>
								<aside>

									{menu &&
										<Box
											sx={{
												width: '100%',
												m: {
													xs: '0',
													md: '32px auto 32px 0'
												},
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'flex-start',
												justifyContent: 'flex-start'
											}}
										>
											<Typography variant='h3' sx={{ mb: '0.4rem' }}>
												Quick Links
											</Typography>
											{Object.values(menu).map((item) => {
												return (

													<Link
														key={item.ID}
														component={RouterLink}
														to={item.url}
														sx={{
															m: '0.25rem 0 !important',
															display: 'block'
														}}
													>
														{item?.title ? he.decode(item.title) : ''}
													</Link>


												);
											})}
										</Box>
									}
								</aside>
							</Grid>
						}
					</Grid>
				</Fade>
				{pageData?.acf?.image_background?.bg_title !== '' &&
					<ImageBGSection content={pageData?.acf?.image_background} loading={null} />
				}
			</Container >

		</>
	)
}